import * as Yup from "yup";

import {SubscriptionType} from "@/lib/types/statuspages";

export type SubscribeResult =
  | {
      __typename: "PublicStatusPageSubscribeSuccess";
      status: string;
      data: {verification_required: boolean; rss_url: string | null};
    }
  | {__typename: "ErrorResponse"; status: string; message: unknown};

export interface SubscribeFormValues {
  target: string;
}

const emailSchema = Yup.object({
  target: Yup.string().email("Invalid email address").required("Email address is required"),
});

const smsSchema = Yup.object({
  target: Yup.string().required("Phone number is required"),
});

const rssSchema = Yup.object({
  target: Yup.string().default(""),
});

const slackSchema = Yup.object({
  target: Yup.string().default(""),
});

const webhookSchema = Yup.object({
  target: Yup.string().url("Invalid webhook URL").required("Webhook URL is required"),
});

export const schemaByType: Record<SubscriptionType, Yup.ObjectSchema<{target: string}>> = {
  [SubscriptionType.EMAIL]: emailSchema,
  [SubscriptionType.SLACK]: slackSchema,
  [SubscriptionType.RSS]: rssSchema,
  [SubscriptionType.SMS]: smsSchema,
  [SubscriptionType.WEBHOOK]: webhookSchema,
};
